import React, { useEffect, useState, useRef } from "react";
import { message, notification } from 'antd';
import { Base64 } from "js-base64";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import dayjs from "dayjs";
import { DescriptionText, FlexContainer, H1Text, H2Text, LeftBackButtonText, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
  addPaymentButtonChargeById,
  getPaymentButtonById,
  BASE_URLS,
  getSecretValuesById,
  getCheckoutReconnection,
  getQrPaymentReconnection,
  getHealthCheck,
  addCheckoutPageChargeById,
  addPaymentButtonPageChargeById,
  getPaymentButtonChallanCharges,
  getPaymentButtonCardCharges,
  getServerEncription,
  generateClientKeyPair,
  encryptData,
  getPayPalClientToken,
  getMrn,
  action,
  getWalletOrderInfo,
  confirmWalletOrderInfo,
} from "../../api";
import { MESSAGES, PAYMENT_BUTTON_STATUSES, SWIREPAY_URL, TabNames, NETBANKING_LIST, QR_STATUSES, SESSION_TIME, TANGEDCO_PG, LPG_CUSTOMER, ACQUIRER_TYPE_PAYPAL, ACQUIRER_TYPE_PAYPAL_BNY } from "../../appconstants";
import { AmountDivideByHundred } from "../../helper";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import { formatToE164 } from "../../utils/formatToE164";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achPaymentWithPlaid";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import BankPayment from "../../components/bankpayment/BankPayment";
import PayPalCheckout from "../paypalCheckout";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import NetBanking from "../../components/netbanking/NetBanking";
import GooglePay from "../../components/googlePay/GooglePay";
import PayPalGooglePay from "../../components/payPalGooglePay";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";
import ChallanPayment from "../../components/challanpayment/ChallanPayment";
import Apple from '../../routes/apple';
import ApplePayButton from '../../routes/apple/PayPalApplePay';
// import ButtonApplePay from "../apple/ApplePay";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import RecaptchaModal from "../../components/recaptcha";
import AlertModal from "../../components/modal/alert";
import ExclamationWarning from "../../assets/imgs/exclamation_warning.svg";
import { getCountryCallingCode } from "libphonenumber-js";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";


type Props = {
  history: {
    push: Function,
  },
}

const PaymentButton = (props: Props) => {

  const { match: { params: { paymentButtonId } }, location: { pathname, search } } = props;
  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [payment, setPayment] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
  const [submitBtnText, setSubmitBtnText] = useState(null);
  const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${paymentButtonId}-tap-index`) || 0));
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
  const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
  const [tabName, setTabName] = useState('');
  const [userType, setUserType] = useState('');
  const [banksList, setBanksList] = useState(null);
  const [supportPhoneNumber, setSupportPhoneNumber] = useState();
  const [isTest, setIsTest] = useState(null);
  const [bankTypes, supportedBankTypes] = useState([null]);
  const [bankImageUrl, setBankImageUrl] = useState(null);
  const [partnerImageUrl, setPartnerImageUrl] = useState(null);
  const [gpaySecretValues, setGpaySecretValues] = useState(null);
  const [gpayError, setGpayError] = useState(null);
  const [processStatus, setProcessStatus] = useState(false);
  const hostName = (window && window.location && window.location.host);
  const [ipAddress, setIpAddress] = useState('');
  const [upiDownTime, setUpiDownTime] = useState(false);
  const [convenience, setConvenience] = useState(0);
  const [gst, setGst] = useState(0);
  const [totalAmount, setTotalAmount] = useState(null);
  const [applePayment, setApplePayment] = useState(false);
  const [isApplePay, setIsApplePay] = useState(false);
  const [swirepayUS, setSwirepayUS] = useState(false);
  const [googlePayUs, setGooglePayUs] = useState(false);
  const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
  const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
  const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
  const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
  const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
  const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
  const [paymentLinkGlobalRecaptcha, setPaymentLinkGlobalRecaptcha] = useState(null);
  const accountGid = [
    'account-cdfe7eecff324778a88a2727177a1c8f'
  ];
  const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${paymentButtonId}`) || undefined);
  const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
  const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
  const dispatch = useDispatch();
  const [payPalClientAuth, setPayPalClientAuth] = useState('');
  const [payPalClientId, setPaypalClientId] = useState('');
  const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
  const isPayPalApple = useRef(false);
  const isPayPalGoogle = useRef(false);
  const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
  const paypalPaymentData = useRef(null);
  const [orderDatas, setOrderData] = useState();
  const commonRecaptchaToken = useRef(null);
  const paymentSessionGidRef = useRef(null);
  const redirectUrlRef = useRef(null);
  const upiAppPsClientSecretRef = useRef(null);
  const paymentButtonReceiptNumber = useRef(null);

  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  useState(() => {
    if (window.ApplePaySession) {
      setIsApplePay(true);
    }
  }, []);

    const getPayPalAccountInfo = async(id) => {
    try{
      const payPalInfo = await getPayPalClientToken(id);
      const value = Base64.decode(payPalInfo);
      const value_json = JSON.parse(value);
      setPaypalClientId(value_json?.clientId);
      setPayPalClientAuth(payPalInfo);
      return payPalInfo;
    } catch(e) {
      console.error(e);
    }
    return null;
  }

  useEffect(() => {
    const acquirer = payment?.account?.acquirer;
    if (payment?.account?.gid && (acquirer === ACQUIRER_TYPE_PAYPAL || acquirer === ACQUIRER_TYPE_PAYPAL_BNY)) {
      getPayPalAccountInfo(payment?.account?.gid);
    }
  }, [payment]);

  useEffect(() => {
    if (search) {
      getPaymentButtonDataWithSearchValue();
    } else {
      getPaymentButtonDataWithoutSearchValue();
    }
  }, [paymentButtonId, search]);

  useEffect(() => {
    if (updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails) {
      if (updateCustomerRedux?.customerDetails?.name && updateCustomerRedux?.customerDetails?.name !== '') {
        setPayment((prev) => ({ ...prev, name: updateCustomerRedux.customerDetails.name }));
      };
      if (updateCustomerRedux?.customerDetails?.email && updateCustomerRedux?.customerDetails?.email !== '') {
        setPayment((prev) => ({ ...prev, email: updateCustomerRedux.customerDetails.email }));
      };
      if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
        && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
      ) {
        setPayment((prev) => ({ ...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
      };
      dispatch(setUpdateStatus(false));
    };
  }, [updateCustomerRedux])

  useEffect(() => {
    if (payment && payment.currency && payment.amount) {
      setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency.name)}`)
    }
    setApplePayment(
      payment
      && payment.account
      && payment?.account?.supportedPaymentTypes?.includes('APPLE_PAY_US')
      && Array.isArray(payment?.paymentMethodType)
      && payment.paymentMethodType.includes('WALLET')
    );
    setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
    setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
    if (payment && payment.account && payment.account.paymentTypeOrder) {
      const paymentMethod = payment && payment.paymentMethodType;
      const paymentOrders = payment && payment.account && payment.account.paymentTypeOrder;
      const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
      let newfilterPaymentOrder;
      if (TANGEDCO_PG === payment.account.gid) {
        if (payment.account.paymentTypeOrder) {
          setPaymentTypeOrder([{ category: 'CARD' }]);
        } else setSupportedPaymentTypes(['CARD']);
      } else if (TANGEDCO_PG !== payment.account.gid) {
        if (payment.account && paymentMethod.includes('WALLET')) {
          setPaymentTypeOrder(filterPaymentOrder);
        } else {
          newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
          setPaymentTypeOrder(newfilterPaymentOrder);
        }
      } else {
        setSupportedPaymentTypes(payment && payment.paymentMethodType);
      }
    }

    setSupportPhoneNumber(payment && payment.support && payment.support.phone);
  }, [payment]);

  useEffect(() => {
    if (payment && payment.currency && payment.currency.name !== 'INR') { setSelectedTab(0) }
  }, [selectedTab]);

  const getGooglePayMerchantValues = async (accountGid) => {
    try {
      const values = await getSecretValuesById(accountGid, null);
      setGpaySecretValues(values);
    } catch (error) {
      setGpayError('Missing merchant details. Please contact support');
    }
  };

  const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
    try {
      const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
      if (value) {
        const { status, receiptNumber } = value;
        const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (status === QR_STATUSES.SUCCEEDED) {
          if (!redirectionUri) {
            setTransactionSuccessModalOpen(true);
          }
          setTimeout(function () {
            const uri = getRedirectionUrl(hostName);
            const redirectUrl = redirectionUri ? redirectionUri : '';
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
              window.location = `${redirectUrl}&sp-payment-button=${paymentButtonId}`;
            } else if (!urlPath && redirectUrl) {
              window.location = `${redirectUrl}?sp-payment-button=${paymentButtonId}`;
            } else if (uri && !redirectUrl) {
              window.location = `${uri}receipts/${receiptNumber}`;
            }
          }, timeOut);
          if (paymentButtonId) { localStorage.removeItem(`${paymentButtonId}-tap-index`) }
        }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const getPaymentCharges = async (cardNumber, payments) => {
    setPayment(payments);
    dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
      value: {
        phoneNumber: payments?.phoneNumber ? getCountryCodeAndNumber(payments?.phoneNumber)?.phoneNumber : '',
        countryCode: payments?.phoneNumber ? getCountryCodeAndNumber(payments?.phoneNumber)?.countryCode : '+1',
        name: payments?.name,
        email: payments?.email,
      } 
    }));
    try {
      let value = null;
      if (null != cardNumber) {
        value = await getPaymentButtonCardCharges(paymentButtonId, cardNumber);
      } else {
        value = await getPaymentButtonChallanCharges(paymentButtonId);
      }
      if (value) {
        setConvenience(currencyFormatter(AmountDivideByHundred(value.feeAmount)));
        setGst(currencyFormatter(AmountDivideByHundred(value.taxAmount)));
        setSubmitBtnText(`PAY ${currencyFormatter(AmountDivideByHundred(payments.amount + value.feeAmount + value.taxAmount), payments.currency.name)}`)
        setTotalAmount(currencyFormatter(AmountDivideByHundred(payments.amount + value.feeAmount + value.taxAmount), payments.currency.name));
      }
    } catch (e) {
      setConvenience(0);
      setGst(0);
      setTotalAmount(currencyFormatter(AmountDivideByHundred(payments.amount), payments.currency.name));
    } finally {
      setShowSpinner(false)
    }
  }

  const getPaymentButtonDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await getPaymentButtonById(paymentButtonId, null);
      if (value) {
        const { status, redirectUri } = value;
        if (PAYMENT_BUTTON_STATUSES.ACTIVE !== status) {
          props.history.push(`${pathname}/expired`);
          return;
        }
        // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        // }
        setPayment(value);
        dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
          value: {
            phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
            countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
            name: value?.name,
            email: value?.email,
          } 
        }));
        setBackButtonUrl(redirectUri || SWIREPAY_URL)
        if (value) {
          setPayment(value);
          dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
            value: {
              phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
              countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
              name: value?.name,
              email: value?.email,
            } 
          }));
          if (value.account && value.account.portal) {
            const portal = value.account.portal.test;
            setIsTest(portal);
            setUserType(value.account && value.account.mdr);
            setBankImageUrl(value.account && value.account.bankImageUrl);
            setPartnerImageUrl(value.account && value.account.partnerImageUrl);
            supportedBankTypes(value.account.supportedPaymentTypes);
            if (portal) {
              const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
              setBanksList(supportedBanks);
            } else {
              const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
              setBanksList(supportedBanks);
            }
          }
          if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
            getGooglePayMerchantValues(value && value.account && value.account.gid);
          }
        }
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    } finally {
      setShowSpinner(false);
    }
  };

  const getPaymentButtonDataWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setShowSpinner(true);
    try {
      const value = await getPaymentButtonById(paymentButtonId, search);
      if (value) {
        const { redirectUri, receiptNumber } = value;
        const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        setPayment(value);
        dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
          value: {
            phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
            countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
            name: value?.name,
            email: value?.email,
          } 
        }));
        setUserType(value.account && value.account.mdr);

        if (value) {
          setPayment(value);
          dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
            value: {
              phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
              countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
              name: value?.name,
              email: value?.email,
            } 
          }));
          if (value.account && value.account.portal) {
            const portal = value.account.portal.test;
            setIsTest(portal);
            setBankImageUrl(value.account && value.account.bankImageUrl);
            setPartnerImageUrl(value.account && value.account.partnerImageUrl);
            supportedBankTypes(value.account.supportedPaymentTypes);
            if (portal) {
              const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
              setBanksList(supportedBanks);
            } else {
              const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
              setBanksList(supportedBanks);
            }
          }
        }
        if (!redirectUri) {
          setTransactionSuccessModalOpen(true);
        }
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}?sp-payment-button=${paymentButtonId}`;
          } else if (uri) {
            window.location = `${uri}receipts/${receiptNumber}`;
          }
        }, timeOut);
      }
    } catch (reason) {
      try {
        const value = await getPaymentButtonById(paymentButtonId, null);
        if (value) {
          setPayment(value);
          dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
            value: {
              phoneNumber: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.phoneNumber : '',
              countryCode: value?.phoneNumber ? getCountryCodeAndNumber(value?.phoneNumber)?.countryCode : '+1',
              name: value?.name,
              email: value?.email,
            } 
          }));
          if (PAYMENT_BUTTON_STATUSES.EXPIRED === value.status) {
            props.history.push(`${pathname}/expired`)
          }
        }
      } catch (er) {
        props.history.push(`${pathname}/error`);
      }
      error(reason);
    } finally {
      setShowSpinner(false)
    }
  };

  const error = reason => {
    setErrorMessage(null);
    if (!reason) return;
    const { data: { message, messageCode }, status } = reason;
    if (messageCode === 5102) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setErrorMessage(message);
    if (status === 500) {
      setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
    }
    setTransactionModalOpen(false);
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const chargeByUpi = async (data) => {
    const { customer, paymentMethod, notify } = data;
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
      ip: ipAddress,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent
    };
    paymentMethod.userAgent = userAgent;
    await chargeById({ customerDetails: customer, shouldWhatsAppNotify: notify, paymentMethodDetails: paymentMethod });
  };

  const chargeByAch = async (data) => {
    const { customer, paymentMethod, notify } = data;
    await chargeById({ customerDetails: customer, shouldWhatsAppNotify: notify, paymentMethodDetails: paymentMethod });
  };

  const chargeByInstantPay = async (data) => {
    const { customer, walletAlias, notify } = data;
    const paymentMethod = {
      type: "INSTANT_PAYMENT",
      instantPayment: {
        alias: walletAlias,
        type: "ALIAS",
      },
    };
    await chargeById({ customerDetails: customer, shouldWhatsAppNotify: notify, paymentMethodDetails: paymentMethod });
  };


  const chargeBySwirepayUS = async (data) => {
    const { walletAlias, notify } = data;
    const paymentMethod = {
      type: "WALLET",
      subType: "SWIREPAY_US",
      swirepayUS: {
        alias: walletAlias,
        type: "ALIAS",
      },
    };
    await chargeById({ shouldWhatsAppNotify: notify, paymentMethodDetails: paymentMethod });
  };

  const chargeByCard = async (data) => {
    const { customer, paymentMethod, notify } = data;
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
      ip: ipAddress,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent
    };
    paymentMethod.userAgent = userAgent;
    await chargeById({ customerDetails: customer, shouldWhatsAppNotify: notify, paymentMethodDetails: paymentMethod });
  };

  const chargeByBank = async (data) => {
    const { customer, customerGid, fundingSourceId } = data;
    const paymentMethod = {
      bank: {
        referenceId: fundingSourceId,
      },
      customerGid,
      type: "ACH"
    }
    await chargeById({ customerDetails: customer, paymentMethodDetails: paymentMethod });
  };

  const chargeByNetBanking = async (data) => {
    const { gid, notify } = data;
    const paymentMethod = {
      type: "NET_BANKING",
      netbanking: {
        swirepayBankGid: gid,
      },
    };
    await chargeById({ paymentMethodDetails: paymentMethod, shouldWhatsAppNotify: notify, });
  };

  const addCheckoutPageById = async (data, recaptchaToken = null) => {
    setTransactionModalOpen(true);
    const { customer, paymentMethod } = data;
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        const finaldata = { customerDetails: customer, paymentMethodDetails: paymentMethod }
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify(finaldata), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            const value = await addPaymentButtonPageChargeById(paymentButtonId, payload);
            if (value) {
              const { nextActionUrl, redirectUri } = value;
              const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
              if (nextActionUrl) {
                window.location = nextActionUrl;
                return;
              }
              setTransactionModalOpen(false);
              if (!redirectUri) {
                setTransactionSuccessModalOpen(true);
              }
              setTimeout(function () {
                const redirectUrl = redirectUri ? redirectUri : SWIREPAY_URL;
                const urlPath = redirectUrl.includes("?");
                if (urlPath) {
                  window.location = `${redirectUrl}&sp-checkout-page=${paymentButtonId}`;
                } else if (!urlPath) {
                  window.location = `${redirectUrl}?sp-checkout-page=${paymentButtonId}`;
                }
                sessionStorage.removeItem("stripeRes");
              }, timeOut);
              if (paymentButtonId) { localStorage.removeItem(`${paymentButtonId}-tap-index`) }
            }

          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429) {
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      setTimeout(function () {
        window.location = payment && payment.redirectUri;
      }, 1000);
      // error(reason);
    }
  };

  const generateChallan = async (data) => {
    await addCheckoutPageById(data);
  };

  const chargeByPaypalGooglePay = async (data, localRecaptchaToken = null) => {
    try {
      paypalPaymentData.current = data;
      setTransactionModalOpen(true);
      setRecaptchaPaymentType('paypalGooglePay');
      const value = await getPayPalAccountInfo(payment?.account?.gid);
      if (value) {
        isPayPalGoogle.current = true;
        const paymentMethod = {
          type: "WALLET",
          subType: "GOOGLE_PAY_US",
          googlePayUS: {
            apiVersionMinor: data.apiVersionMinor,
            apiVersion: data.apiVersion,
            paymentMethodDescription: data.paymentMethodData.description,
            paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
            paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
            paymentMethodType: data.paymentMethodData.type,
            paymentMethodInfo: data.paymentMethodData.info
          },
        };
        const responseEntity = await chargeById({ paymentMethodDetails: paymentMethod }, localRecaptchaToken);
        isPayPalGoogle.current = false;
        const orderId = await getMrn(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
        // Step 2: confirm PayPal order
        await window.paypal.Googlepay().confirmOrder({
          orderId,
          paymentMethodData: data?.paymentMethodData,
        });
        // Step 3: capture/perform final action
        await action(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
        await chargeByIdSuccessActions(responseEntity);
      }
    } catch (err) {
      console.error('Google Pay Failed', err);
      message.error('GooglePay Transaction Failed');
      chargeByIdFailActions();
    } finally {
      setTransactionModalOpen(false);
    }
  };

  const chargeByGooglePay = async (data) => {
      const formattedPhoneNumber = formatToE164(
          data?.paymentMethodData?.info?.billingAddress?.phoneNumber,
          data?.paymentMethodData?.info?.billingAddress?.countryCode
      );
      const customer = {
        name: data?.shippingAddress?.name || data?.paymentMethodData?.info?.billingAddress?.name || "",
        email: data?.email || "",
        phoneNumber: formattedPhoneNumber,
      }
      const paymentMethod = {
          type: "WALLET",
          subType: "GOOGLE_PAY_US",
          googlePayUS: {
              apiVersionMinor: data.apiVersionMinor,
              apiVersion: data.apiVersion,
              paymentMethodDescription: data.paymentMethodData.description,
              paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
              paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
              paymentMethodType: data.paymentMethodData.type,
              paymentMethodInfo: data.paymentMethodData.info
          },
      };
      setRecaptchaPaymentType('cardPointGooglePay');
      await chargeById({ paymentMethodDetails: paymentMethod, customer }, cardPointGooglePayToken);
  };

  const chargeByIdSuccessActions = async (value) => {
    const { nextActionUrl, redirectUri, receiptNumber, paymentStatus } = value;
    if (paymentStatus && paymentStatus === 'PROCESSING') {
      setProcessStatus(true);
    }
    const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
    if (nextActionUrl) {
      window.location = nextActionUrl;
      return;
    }
    setTransactionModalOpen(false);
    if (!redirectUri) {
      setTransactionSuccessModalOpen(true);
    }
    setTimeout(function () {
      const uri = getRedirectionUrl(hostName);
      const redirectUrl = redirectUri ? redirectUri : '';
      const urlPath = redirectUrl.includes("?");
      if (urlPath) {
        window.location = `${redirectUrl}&sp-payment-button=${paymentButtonId}`;
      } else if (uri && !redirectUrl) {
        if (receiptNumber) {
          window.location = `${uri}receipts/${receiptNumber}`;
        } else window.location = SWIREPAY_URL;
      } else if (!urlPath && redirectUrl) {
        window.location = `${redirectUrl}?sp-payment-button=${paymentButtonId}`;
      }
      sessionStorage.removeItem("stripeRes");
    }, timeOut);
    if (paymentButtonId) { localStorage.removeItem(`${paymentButtonId}-tap-index`) }
  };

  const chargeByIdFailActions = async () => {
    setTransactionModalOpen(false);
  };

  const chargeByApple = async (paymentData, recaptchaToken = null) => {
    const {
      deviceData,
      amount,
      customerName,
      customerEmail,
      customerPhone,
      countryCode,
      stateCode,
      street,
      postalCode,
      city,
      cardNetwork,
      cardType,
      cardLast4,
    } = paymentData;
    const billingAddress = {
      city: city,
      countryCode: countryCode,
      state: stateCode,
      street: street
    };
    setRecaptchaPaymentType('paypalApplePay');
    const paymentMethod = {
      applePayUS: {
        deviceData: deviceData,
        cardBrand: cardNetwork,
        cardFundingType: cardType,
        applePayDynamicLast4: cardLast4,
        cardLast4: cardLast4
      },
      type: "WALLET",
      subType: "APPLE_PAY_US",
      postalCode: postalCode,
      paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
    }
    let customer = {
      email: customerEmail,
      name: customerName,
      phoneNumber: customerPhone
    }
    const value = await getPayPalAccountInfo(payment?.account?.gid);
    if (value) {
      isPayPalApple.current = true;
    }
    const responseEntity = await chargeById({
        paymentMethodDetails: paymentMethod,
        customerGid: getCustomerGidFromPayment(payment),
        customerDetails: customer,
      }, recaptchaToken);
    isPayPalApple.current = false;
    return responseEntity;
  }

  const chargeByCardpointeApplePay = async (paymentData) => {
    const {
      deviceData,
      // amount,
      customerName,
      customerEmail,
      customerPhone,
      countryCode,
      stateCode,
      street,
      postalCode,
      city,
      cardNetwork,
      cardType,
      cardLast4,
    } = paymentData;
    
    const billingAddress = {
      city: city,
      countryCode: countryCode,
      state: stateCode,
      street: street
    };

    const paymentMethod = {
      applePayUS: {
        deviceData: deviceData,
        cardBrand: cardNetwork,
        cardFundingType: cardType,
        applePayDynamicLast4: cardLast4,
        cardLast4: cardLast4
      },
      type: "WALLET",
      subType: "APPLE_PAY_US",
      postalCode: postalCode,
      paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
    }

    let customer = {
      email: customerEmail,
      name: customerName,
      phoneNumber: customerPhone,
    }

    await chargeById({
      paymentMethodDetails: paymentMethod,
      customerGid: getCustomerGidFromPayment(payment),
      customerDetails: customer,
    }, null);
  };

  const getCustomerGidFromPayment = () => {
    return payment && payment.customer && payment.customer.gid;
  };

  const chargeByUpiIndent = async (data, recaptchaToken = null) => {
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify({ paymentMethodDetails: data?.paymentMethod }), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            const value = await addPaymentButtonChargeById(paymentButtonId, payload);
            if (value) {
              const { nextActionUrl, redirectUri, receiptNumber } = value;
              paymentSessionGidRef.current = value?.paymentSessionGid;
              upiAppPsClientSecretRef.current = value?.psClientSecret;
              redirectUrlRef.current = redirectUri;
              paymentButtonReceiptNumber.current = receiptNumber;
              return (nextActionUrl || null);
            }
          }
        }
      }
      return null;
    } catch (reason) {
      if (reason?.status === 429) {
        setRecaptchaPaymentType('upi_indent');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const handleRedirect = () => {
    const uri = getRedirectionUrl(hostName);
    const redirectUrl = redirectUrlRef?.current || '';
    const hasQuery = redirectUrl.includes('?');

    let finalUrl = '';

    if (redirectUrl) {
      finalUrl = hasQuery
        ? `${redirectUrl}&sp-payment-button=${paymentButtonId}`
        : `${redirectUrl}?sp-payment-button=${paymentButtonId}`;
    } else if (uri && paymentButtonReceiptNumber?.current) {
      finalUrl = `${uri}receipts/${paymentButtonReceiptNumber.current}`;
    } else {
      finalUrl = SWIREPAY_URL;
    }

    window.location = finalUrl;

    // cleanup
    sessionStorage.removeItem("stripeRes");
    if (paymentButtonId) {
      localStorage.removeItem(`${paymentButtonId}-tap-index`);
    }
  };

  const onReturnFromUpiApp = async () => {
    setTransactionModalOpen(true);

    try {
      const paymentSessionId = paymentSessionGidRef?.current;
      const clientSecret = upiAppPsClientSecretRef?.current;

      if (!paymentSessionId || !clientSecret) {
        handleRedirect();
        return;
      }

     // poll to check if the transaction has processed
      let entity;
      let attempts = 0;
      const MAX_ATTEMPTS = 15; // poll every 1s for upto 15 seconds
      const POLLING_INTERVAL = 1000;
      while (attempts < MAX_ATTEMPTS) {
        const response = await action(paymentSessionId, clientSecret);
        entity = response?.data?.entity;
        if (entity?.status === 'REQUIRE_ACTION') {
          await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
          attempts++;
        } else {
          break;
        }
      }

      if (entity?.status === 'SUCCEEDED') {
        setTransactionSuccessModalOpen(true);

        const timeout = redirectUrlRef?.current
          ? SESSION_TIME.REDIRECT_URL
          : SESSION_TIME.NO_REDIRECT_URL;

        setTimeout(() => {
          handleRedirect();
        }, timeout);

        return;
      }

      // Failed or other status
      handleRedirect();

    } catch (error) {
      console.error("UPI return error:", error);
      handleRedirect();
    } finally {
      setTransactionModalOpen(false);
    }
  };

  const chargeById = async (data, recaptchaToken = null) => {
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            const value = await addPaymentButtonChargeById(paymentButtonId, payload);
            if (value) {
              if (!isPayPalApple.current
                && !isPayPalGoogle.current
              ) {
                await chargeByIdSuccessActions(value);
              }
              return value;
            }
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429) {
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const onGlobalCaptchaVerified = async (token) => {
    setRecaptchaModalVisible(false);
    switch (recaptchaPaymentType) {
      case TabNames.UPI:
        setPaymentLinkUpiGlobalRecaptcha(token);
        break;
      case TabNames.INSTANT_PAYMENT:
        setPaymentLinkInstantPaymentGlobalRecaptcha(token);
        break;
      case 'paypalApplePay':
        setPaypalApplePayRecaptcha(token);
        setPaypalApplePayMessageModal(true);
        break;
      case 'paypalGooglePay':
        if (paypalPaymentData.current) {
          chargeByPaypalGooglePay(paypalPaymentData.current, token);
        }
        break;
      case 'cardPointGooglePay':
        setCardPointGooglePayToken(token);
        break;
      case 'payPalButton':
        commonRecaptchaToken.current = token;
        break;
      case 'upiIndent':
        chargeByUpiIndent(savedPaymentDetails, token);
        break;
      default:
        chargeById(savedPaymentDetails, token);
    }
    setRecaptchaPaymentType(null);
  }

  const getPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
    try {
      const value = await getCheckoutReconnection(paymentSession, psClientSecret);
      if (value) {
        const { status, receiptNumber } = value;
        const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (status === QR_STATUSES.SUCCEEDED) {
          if (!redirectionUri) {
            setTransactionSuccessModalOpen(true);
          }
          setTimeout(function () {
            const uri = getRedirectionUrl(hostName);
            const redirectUrl = redirectionUri ? redirectionUri : '';
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
              window.location = `${redirectUrl}&sp-payment-button=${paymentButtonId}`;
            } else if (!urlPath && redirectUrl) {
              window.location = `${redirectUrl}?sp-payment-button=${paymentButtonId}`;
            } else if (uri && !redirectUrl) {
              window.location = `${uri}receipts/${receiptNumber}`;
            }
          }, timeOut);
          if (paymentButtonId) { localStorage.removeItem(`${paymentButtonId}-tap-index`) }
        }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const onApprove = async (data) => {
    try {
      await confirmWalletOrderInfo(orderDatas?.paymentSessionGid, orderDatas?.psClientSecret);
      setTransactionSuccessModalOpen(true);
      const timeOut = SESSION_TIME.NO_REDIRECT_URL;
      setTimeout(function () {
        window.location = payment?.redirectUri || SWIREPAY_URL;
      }, timeOut);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const createOrder = async (paypalData, actions) => {
    try {
      const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let data = {};
          if (paypalData?.paymentSource === 'paypal') {
            data = {
              paymentMethodDetails: {
                payPalWallet: {
                  rawData: {
                    experience_context: {
                      payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                      landing_page: "LOGIN",
                      return_url: payment?.redirectUri || SWIREPAY_URL,
                      cancel_url: payment?.redirectUri || SWIREPAY_URL,
                    }
                  }
                },
                type: "WALLET",
                subType: "PAYPAL_WALLET"
              }
            }
          } else if (paypalData?.paymentSource === 'venmo') {
            data = {
              paymentMethodDetails: {
                venmo: {
                  rawData: {
                    experience_context: {
                      payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                      landing_page: "LOGIN",
                      return_url: payment?.redirectUri || SWIREPAY_URL,
                      cancel_url: payment?.redirectUri || SWIREPAY_URL,
                    }
                  }
                },
                type: "WALLET",
                subType: "VENMO"
              }
            }
          }
          const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            const value = await addPaymentButtonChargeById(paymentButtonId, payload);
            commonRecaptchaToken.current = null;
            if (value?.paymentSessionGid) {
              setOrderData(value)
              const orderData = await getWalletOrderInfo(value?.paymentSessionGid, value?.psClientSecret);
              if (!orderData.id) {
                const errorDetail = orderData.details[0];
                const errorMessage = errorDetail
                  ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                  : "Unexpected error occurred, please try again.";

                throw new Error(errorMessage);
              }
              return orderData?.id;
            }
          }
        }
      }
    } catch (error) {
      if (error?.status === 429) {
        setSavedPaymentDetails(paypalData);
        setRecaptchaPaymentType('payPalButton');
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        throw new Error('Recatpcha Required');
      }
      console.error(error);
      throw error || new Error('Unexpected error occurred, please try again.');
    }
  };

  const chargeBySavedPaymentMethods = async (data) => {
    await chargeById({ paymentMethodDetails: data });
  };

  const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
  if (uniquePaymentTypes.includes('WALLET')) {
    if (swirepayUS) {
      uniquePaymentTypes.push('SWIREPAY_US');
    }
    if (!googlePayUs) {
      const index = uniquePaymentTypes.indexOf('WALLET');
      if (index > -1) {
        uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
      }
    }
  }
  const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
    let children;
    let id;

    if (name === TabNames.ACH_LEGACY) {
      children = <AchPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByAch}
        preFillCustomer={payment}
        customerEnabled={true}
        headerText={accountGid.includes(payment?.account?.gid) ? "Pay With BANK" : "Pay With ACH"}
        buttonText={submitBtnText}
        showWhatsAppNotify={false}
        customerValidation={true}
        isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
        plaidPublicToken={plaidPublicToken}
        setPlaidPublicToken={setPlaidPublicToken}
        accountGid={payment?.account?.gid}
        paymentLinkId={paymentButtonId}
        isTest={payment?.account?.portal?.test}
        enableConsentCheckbox={true} 
        prefix={payment?.currency?.prefix}
        accountName={payment?.account?.name}
        paymentDate={dayjs().format('MMMM D, YYYY')}
        finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
      />
      id = name;
    } else if (name === TabNames.CARD) {
      children = <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByCard}
        showWhatsAppNotify={false}
        preFillCustomer={payment}
        headerText={"Pay With Card"}
        buttonText={submitBtnText}
        isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
        isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
        customerValidation={true}
        requiredPhone={true}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
        payments={payment}
      />
      id = name;
    } else if (name === TabNames.UPI) {
      children = <UpiPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByUpi}
        preFillCustomer={payment}
        headerText={"Pay With UPI"}
        buttonText={submitBtnText}
        customerValidation={true}
        getPaymentById={getPaymentById}
        showWhatsAppNotify={false}
        paymentMethodDetails={true}
        hideQr={false}
        showMobileViewUpi={true}
        supportPhoneNumber={supportPhoneNumber}
        upiUrl={`${BASE_URLS.PAYMENT_BUTTON}/${paymentButtonId}`}
        supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
        onReturnFromUpiApp={onReturnFromUpiApp}
        onChargeByUpiIndent={chargeByUpiIndent}
        acquirer={payment?.account?.acquirer}
      />
      id = name;
    } else if (name === TabNames.ACH) {
      children = <BankPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerDisabled={false}
        submit={chargeByBank}
        preFillCustomer={payment}
        headerText={"Pay With Bank Transfer"}
        buttonText={submitBtnText}
        showWhatsAppNotify={false}
        iavUrl={`${BASE_URLS.PAYMENT_BUTTON}/${paymentButtonId}`}
        customerValidation={true}
        requiredPhone={true}
        publicKey={payment && payment.account && payment.account.usPublicKey}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
      />
      id = name;
    } else if (name === TabNames.NET_BANKING) {
      children = <NetBanking
        showCancelBtn={payment && payment.canDecline}
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByNetBanking}
        showWhatsAppNotify={false}
        preFillCustomer={payment}
        headerText={"PAY WITH NET BANKING"}
        cancelButtonText={"Decline"}
        buttonText={submitBtnText}
        customerValidation={true}
        banksList={banksList}
        bankTypes={bankTypes}
        isTest={isTest}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
      />
      id = name;
    } else if (name === TabNames.CHALLAN) {
      children = <ChallanPayment
        showCancelBtn={payment && payment.canDecline}
        hideCustomer={true}
        showBillDetails={true}
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={generateChallan}
        preFillCustomer={payment}
        checkoutPageId={paymentButtonId}
        headerText={"Pay With Challan"}
        cancelButtonText={"Decline"}
        buttonText={submitBtnText}
        customerValidation={true}


        prefix={payment && payment.currency && payment.currency.prefix}
        billAmount={`${currencyFormatter(AmountDivideByHundred(payment && payment.amount), payment && payment.currency && payment.currency.name)}`}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
        userType={userType}
        payments={payment && payment}
        payment={payment}
        getPaymentCharges={getPaymentCharges}
        convenience={convenience}
        gst={gst}
        totalAmount={totalAmount}
      />
      id = name;
    } else if (name === TabNames.GOOGLE_PAY_US) {
      children = <>
        {
          payPalClientAuth ? (
            <PayPalGooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByPaypalGooglePay}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
              accountGid={payment?.account?.gid}
              setTransactionModalOpen={setTransactionModalOpen}
            />
          ) : (
            <GooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByGooglePay}
              gpaySecretValues={gpaySecretValues}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
            />
          )
        }
      </>
      id = name;
    } else if (name === TabNames.WALLET) {
      children = <>
        {
          payPalClientAuth ? (
            <PayPalGooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByPaypalGooglePay}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
              accountGid={payment?.account?.gid}
              setTransactionModalOpen={setTransactionModalOpen}
            />
          ) : (
            <GooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={chargeByGooglePay}
              gpaySecretValues={gpaySecretValues}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
            />
          )
        }
      </>
      id = name;
    } else if (name === TabNames.INSTANT_PAYMENT) {
      children = <InstantPayment
        showCancelBtn={payment && payment.canDecline}
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        requiredPhone={true}
        submit={chargeByInstantPay}
        preFillCustomer={payment}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        customerValidation={true}
        cancelButtonText={"Decline"}
        showWhatsAppNotify={false}
        hideQr={false}
        getPaymentById={getQrPaymentById}
        paymentMethodDetails={true}
        upiUrl={`${BASE_URLS.PAYMENT_BUTTON}/${paymentButtonId}`}
        showCustomer={true}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === TabNames.SWIREPAY_US) {
      children = <InstantPayment
        showCancelBtn={payment && payment.canDecline}
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        requiredPhone={true}
        submit={chargeBySwirepayUS}
        preFillCustomer={payment}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        customerValidation={true}
        cancelButtonText={"Decline"}
        showWhatsAppNotify={false}
        hideQr={false}
        getPaymentById={getQrPaymentById}
        paymentMethodDetails={true}
        upiUrl={`${BASE_URLS.PAYMENT_BUTTON}/${paymentButtonId}`}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
        swirepayUS={swirepayUS}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === "APPLE_PAY_US") {
        children = <>{payPalClientAuth ? <ApplePayButton recaptchaToken={paypalApplePayRecaptcha} amount={payment && payment.amount} chargeByApple={chargeByApple} payment={payment}  accountGid={payment?.account?.gid} successCallback={chargeByIdSuccessActions} failCallback={chargeByIdFailActions}/> : <Apple amount={payment && payment.amount} chargeByApple={chargeByCardpointeApplePay} payment={payment}  accountGid={payment?.account?.gid}/>}</>
    } else {
      children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
    }
    panel.push({ children, id });
    return panel;
  }, []) : [
    {
      children: <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={chargeByCard}
        preFillCustomer={payment}
        showWhatsAppNotify={false}
        headerText={"Pay With Card"}
        buttonText={submitBtnText}
        isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
        isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
        customerValidation={true}
        requiredPhone={true}
        alpha2={payment && payment.currency && payment.currency.countryAlpha2}
        payments={payment}
      />,
      id: 'CARD'
    }
  ]


  const tabPanelsApple = {
    children :
    <>
      {payPalClientAuth
        ? (
          <ApplePayButton
            recaptchaToken={paypalApplePayRecaptcha}
            amount={payment && payment.amount}
            chargeByApple={chargeByApple}
            payment={payment}
            accountGid={payment?.account?.gid}
            successCallback={chargeByIdSuccessActions}
            failCallback={chargeByIdFailActions}
          /> ) : (
            <Apple
              amount={payment && payment.amount}
              chargeByApple={chargeByCardpointeApplePay}
              payment={payment}
              accountGid={payment?.account?.gid}
            />
          )}
    </>,
    id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
  };

  if (applePayment
    && isApplePay
  ) {
    tabPanels.push(tabPanelsApple);
  }

  if (payment?.account?.country?.alpha2 === 'US') {
    tabPanels.push({
      children: <SavedPaymentMethods
                  buttonText={submitBtnText}
                  submit={chargeBySavedPaymentMethods}
                  supportedPaymentTypes={uniquePaymentTypes}
                />,
      id: 'SAVED_PAYMENT_METHODS'
    });
  }

  if (payPalClientAuth && payPalClientId && payment?.paymentMethodType?.includes('WALLET') && (payment?.account?.supportedPaymentTypes?.includes('PAYPAL_WALLET') || payment?.account?.supportedPaymentTypes?.includes('VENMO'))) {
    tabPanels.push({
      children: <div style={{ width: '200px'}} >
      <PayPalCheckout
        styles={{ shape: "rect", layout: "vertical" }}
        createOrder={createOrder}
        onApprove={onApprove}
        payPalClientId={payPalClientId}
        currency={payment?.account?.currency?.name || 'USD'}
        country={payment?.account?.country?.alpha2 || 'US'}
        accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
      />
      </div>,
      id: 'PAYPAL_METHOD',
    });
    uniquePaymentTypes.push('PAYPAL_METHOD');
  }

  useEffect(() => {
    setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
  }, [selectedTab, uniquePaymentTypes]);
  const agregatorName = payment && payment.account && payment.account.aggregatorName;


  return (
    <BaseSplitPage
      errorHeader={null}
      errorMsg={errorMessage}
      left={
        <>
          <FlexContainer
            flexDirection="column"
            position="relative"
            display="block"
            height="100%"
          >
            <div>
              {
                (payment && payment.account && payment.account.largeLogo) && (
                  <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                )
              }
              <H1Text>
                Payment Checkout
              </H1Text>
              <H2Text>
                Payment For
              </H2Text>
              <DescriptionText>
                {payment && payment.description}
              </DescriptionText>
              <H2Text>
                Amount Payable
              </H2Text>
              <DescriptionText fontSize="24px">
                {payment ? `${currencyFormatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
              </DescriptionText>
              {/* {
                payment?.account?.gid ? (
                  <>
                    <ButtonApplePay
                      accountGid={payment?.account?.gid}
                      currency={payment?.currency?.name}
                      test={true}
                      amount={payment?.amount}
                      apiKey={'sk_live_pdfs2AmTVUhArTOv088qGVupBWosjiCq'}
                      successCallback={chargeByIdSuccessActions}
                      failCallback={chargeByIdFailActions}
                    />
                    <PayPalGooglePayButton
                      accountGid={payment?.account?.gid}
                      test={true}
                      amount={payment?.amount}
                      apiKey="sk_live_aOhh8d6PdoDUtPWp22fGfqECltOQy1Yy"
                      processStartCallaback={() => setTransactionModalOpen(true)}
                      successCallback={chargeByIdSuccessActions}
                      failCallback={chargeByIdFailActions}
                      currencyDetail={{
                        countryAlpha2: payment?.currency?.countryAlpha2,
                        code: payment?.currency?.name,
                      }}
                      countryCallingCode="+1"
                    />
                  </>
                ) : (
                  <></>
                )
              }*/}

            </div>
            <div style={{ position: "sticky", top: "85%" }}>
              <Support email={payment && payment.support && payment.support.email}
                partnerImageUrl={partnerImageUrl}
                bankImageUrl={bankImageUrl}
                whiteLabel={payment && payment.account && payment.account.whiteLabel}
                phone={payment && payment.support && payment.support.phone} />
              {agregatorName === 'EPAYMENTS' ?
                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                  <a href="https://www.swirepay.com" target="_blank" >
                    <img src={EPaymentImg} alt="" />
                  </a>
                </div>
                :
                agregatorName === 'OMEGAITR' ?
                  <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                    <a href="https://www.swirepay.com" target="_blank" >
                      <img src={OMEGAITRlogo} alt="" />
                    </a>
                  </div>
                  :
                  ''
              }
            </div>
          </FlexContainer>
        </>
      } right={
        <>
          <Header
            payment={payment}
            bankImageUrl={bankImageUrl}
            cancelUrlLink={null}
          />
          {/* {
                payment?.account?.gid ? (
                  <ButtonApplePay
                    accountGid={payment?.account?.gid}
                    currency={payment?.currency?.name}
                    test={true}
                    amount={payment?.amount}
                    apiKey={'sk_live_pdfs2AmTVUhArTOv088qGVupBWosjiCq'}
                    successCallback={chargeByIdSuccessActions}
                    failCallback={chargeByIdFailActions}
                  />
                ) : (
                  <></>
                )
              }*/}
          {payment?.account?.country?.alpha2 === 'US' ? (
            <PaymentExpandableRowsV2
              name={paymentButtonId}
              paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
              tabs={uniquePaymentTypes}
              tabPanels={tabPanels}
              onSelect={data => setSelectedTab(data)}
              defaultSelectedTab={selectedTab || 0} tabName={tabName}
              upiDown={upiDownTime}
              applePayment={applePayment}
              isApplePay={isApplePay}
              accountGid={payment?.account?.gid}
              supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
              account={payment?.account}
            />
          ) : (
            <PaymentExpandableRows
              name={paymentButtonId}
              paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
              tabs={uniquePaymentTypes}
              tabPanels={tabPanels}
              onSelect={data => setSelectedTab(data)}
              defaultSelectedTab={selectedTab || 0} tabName={tabName}
              upiDown={upiDownTime}
              applePayment={applePayment}
              isApplePay={isApplePay}
              accountGid={payment?.account?.gid}
              offerRequired={payment?.account?.enableAcquirerOffer || false}
              amount={payment?.amount}
            />
          )}
          <RecaptchaModal
            visible={recaptchaModalVisible}
            onVerified={onGlobalCaptchaVerified}
          />
          <SmallScreenFooter
            partnerImageUrl={partnerImageUrl}
            bankImageUrl={bankImageUrl}
            whiteLabel={payment && payment.account && payment.account.whiteLabel}
          />
          <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
          <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} manualPlaidPayment={manualPlaidPayment} />
          <AlertModal
            isOpen={paypalApplePayMessageModal}
            header="User Action Required"
            showSubmitBtn={true}
            submitBtnText="Ok"
            submit={() => setPaypalApplePayMessageModal(false)}
            body="Please click on Apple Pay again to pay through it."
            icon={ExclamationWarning}
            showIcon={true}
          />
          <Spinner isOpen={isShowSpinner} />
        </>
      } />
  )
};

export default PaymentButton;
